<template>
  <v-container>
    <span>
      <codemirror ref="cmEditor" :value="codeStart" :options="cmOptionsStart" @ready="onCmReady" />
      <codebody :oldCode="code" @code="newCode" @line="setNumberOfLine"></codebody>
      <codemirror ref="cmEditorEnd" :value="codeEnd" :options="cmOptionsEnd" @ready="onCmReady" />
    </span>
  </v-container>
  <!-- Or manually control the data synchronization -->
</template>

<script>
import { codemirror } from "vue-codemirror";

// import base style
import "codemirror/lib/codemirror.css";

// import language js
import "codemirror/mode/javascript/javascript.js";

import ManageAlertCodeBodyComponent from "./ManageAlertCodeBody";

export default {
  props:{
    code: String,
  },
  components: {
    codemirror,
    codebody: ManageAlertCodeBodyComponent,
  },
  data() {
    return {
      numberOfLine: 0,
      codeStart: "function fct(data){",
      codeEnd: "      }",
      cmOptionsStart: {
        readOnly: true,
        tabSize: 4,
        lineNumbers: true,
        line: true,
        mode: "text/javascript",
        theme: "default"
      },
      cmOptionsEnd: {
        readOnly: true,
        tabSize: 4,
        lineNumbers: true,
        line: true,
        mode: "text/javascript",
        theme: "default"
      }
    };
  },
  methods: {
    newCode(value){
      this.$emit("newCode",value);
    },
    setNumberOfLine(numberofline) {
      //
      this.numberOfLine = numberofline + 1;
    },
    onCmReady(cm) {
      cm.setSize("100%", "40px");
      //console.log("the editor is readied!", cm);
    }
  },
  computed: {
    codemirrorend() {
      return this.$refs.cmEditorEnd.codemirror;
    },
    codemirror() {
      return this.$refs.cmEditor.codemirror;
    }
  },
  watch: {
    numberOfLine: function(value) {
      this.codemirrorend.setOption("firstLineNumber", value);
    }
  },
  mounted() {
    //console.log("the current CodeMirror instance object:", this.codemirror);
    // you can use this.codemirror to do something...
    //console.log("the current CodeMirror instance object:", this.codemirrorend);
    // you can use this.codemirror to do something...
  }
};
</script>





